import { tickerItems } from "@/mocks/siteData";

export default function Ticker() {
  const list = [...tickerItems, ...tickerItems];

  return (
    <section className="bg-primary-600 py-3" aria-label="更新速报">
      <div className="flex items-center gap-3 overflow-hidden">
        <span className="ml-4 hidden shrink-0 items-center gap-1.5 rounded-md bg-primary-800 px-3 py-1 text-xs font-medium text-secondary-200 md:inline-flex">
          <i className="ri-broadcast-line" aria-hidden="true" />
          更新速报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap px-4">
            {list.map((item, i) => (
              <span key={`${item}-${i}`} className="flex items-center gap-2 text-sm text-background-50/95">
                <i className="ri-flashlight-line text-secondary-200" aria-hidden="true" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}